__turbopack_context__.v({
  "blockquote": "styles-module-scss-module__f8-WgW__blockquote",
  "error": "styles-module-scss-module__f8-WgW__error",
  "font-inter": "styles-module-scss-module__f8-WgW__font-inter",
  "font-neue-plak": "styles-module-scss-module__f8-WgW__font-neue-plak",
  "heading1-display": "styles-module-scss-module__f8-WgW__heading1-display",
  "heading1-display-cases": "styles-module-scss-module__f8-WgW__heading1-display-cases",
  "heading1-sub": "styles-module-scss-module__f8-WgW__heading1-sub",
  "heading2-compact": "styles-module-scss-module__f8-WgW__heading2-compact",
  "heading2-sub": "styles-module-scss-module__f8-WgW__heading2-sub",
  "heading3-regular": "styles-module-scss-module__f8-WgW__heading3-regular",
  "heading3-regular-alt": "styles-module-scss-module__f8-WgW__heading3-regular-alt",
  "heading3-sub": "styles-module-scss-module__f8-WgW__heading3-sub",
  "input": "styles-module-scss-module__f8-WgW__input",
  "input-label": "styles-module-scss-module__f8-WgW__input-label",
  "input-support": "styles-module-scss-module__f8-WgW__input-support",
  "label-compact": "styles-module-scss-module__f8-WgW__label-compact",
  "label-reg": "styles-module-scss-module__f8-WgW__label-reg",
  "label-small": "styles-module-scss-module__f8-WgW__label-small",
  "lead": "styles-module-scss-module__f8-WgW__lead",
  "link": "styles-module-scss-module__f8-WgW__link",
  "list-item-heading": "styles-module-scss-module__f8-WgW__list-item-heading",
  "list-item-subheading": "styles-module-scss-module__f8-WgW__list-item-subheading",
  "muted": "styles-module-scss-module__f8-WgW__muted",
  "paragraph-reg": "styles-module-scss-module__f8-WgW__paragraph-reg",
  "paragraph-small": "styles-module-scss-module__f8-WgW__paragraph-small",
  "primary": "styles-module-scss-module__f8-WgW__primary",
  "secondary": "styles-module-scss-module__f8-WgW__secondary",
  "typography": "styles-module-scss-module__f8-WgW__typography",
  "white": "styles-module-scss-module__f8-WgW__white",
});
